module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"welcome":"Bienvenue"},"en":{"welcome":"Welcome"}}')
  delete Component.options._Ctor
}
